import * as _ from 'underscore';
import { Injectable } from '@angular/core';
import { TranslationService } from '../translation/translation.service';
import { UntypedFormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

const IMAGE_BASE64:RegExp = /<img src="data:image\/.+;base64,(.+)" \/>/gm;
export const EMAIL_SUFFIX_REGEX:RegExp = /^@+(({isocountry}|[a-z0-9\?\*]|-)+\.|\*)*([a-z0-9]|-)+\.[a-z]+/;
export const EMAIL_ADDRESS_REG_EXP:RegExp = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;

@Injectable()
export class GaFormlyValidatorService {
  constructor(
    private translationService:TranslationService
  ) {
    /**/
  }

  // validates multiple email addresses
  public multipleEmailValidator = {
    expression: (control:UntypedFormControl) => {
      const emailField:string = control?.value;
      if (emailField) {
        const emailAddresses = emailField.split(/,\s{0,1}/);
        return _.every(emailAddresses, (emailAddress:string) => {
          return EMAIL_ADDRESS_REG_EXP.test(emailAddress);
        });
      }
    },
    message: (error:any, field:FormlyFieldConfig) => {
      const emailField:string = field.formControl.value;
      if (emailField) {
        const emailAddresses = emailField.split(/,\s{0,1}/);
        const invalidEmailAddresses:string[] = _.compact(_.filter(emailAddresses, (emailAddress:string) => !EMAIL_ADDRESS_REG_EXP.test(emailAddress)));

        return invalidEmailAddresses.length? this.translationService.instant('GA.VALIDATION.EMAIL_ADDRESS_VALIDATION', { email: invalidEmailAddresses.join(' ' + this.translationService.instant('GA.GENERAL.AND') + ' ') }) : this.translationService.instant('GA.VALIDATION.EMAIL_VALIDATION');
      }
    }
  };

  public workEmailValidator = {
    expression: (control:UntypedFormControl) => {
      const emailField:string = control.value;
      const forbidenDomains:string[] = [
        'gmail',
        'hotmail',
        'yahoo'
      ];

      for (const domain of forbidenDomains) {
        if (new RegExp(`@${domain}\.`, 'g').test(emailField)) {
          return false;
        }
      }
      return true;
    },
    message: this.translationService.instant('GA.VALIDATION.USE_COMPANY_EMAIL')
  };

  public imageValidator = {
    expression: (control:UntypedFormControl) => {
      const fieldValue:string = control.value;
      if (fieldValue) {
        return !fieldValue.match(IMAGE_BASE64);
      }
      return true;
    },
    message: this.translationService.instant('GA.VALIDATION.IMAGE_VALIDATION')
  };
}